import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { DatePicker, RefreshIndicator } from 'material-ui'
import {
  getDashboard,
  resetDashboard,
  getDeveloperDashboard
} from '../../actions/dashboard'
import Header from '../../components/Header/Header'
import DashboardGrid from './Grid/DashboardGrid'
import Constants from '../../utils/CommonConstants'

if (process.env.WEBPACK) {
  require('./Dashboard.css')
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  filters: state.filters,
  dashboard: state.dashboard
})

const mapDispatchToProps = dispatch => {
  return {
    getDashboard: bindActionCreators(getDashboard, dispatch),
    resetDashboard: bindActionCreators(resetDashboard, dispatch),
    getDeveloperDashboard: bindActionCreators(getDeveloperDashboard, dispatch),
    dispatch
  }
}

class Dashboard extends Component {
  constructor(props) {
    super(props)
    const today = new Date()
    this.state = {
      startDate:
        props.filters && props.filters.startDate
          ? props.filters.startDate
          : new Date(today),
      endDate:
        props.filters && props.filters.endDate
          ? props.filters.endDate
          : new Date(today),
      dashboardType: props.route.dashboardType
    }
    this.dashboardType = props.route.dashboardType
  }

  componentDidMount() {
    if (
      this.state.startDate &&
      this.state.endDate &&
      (!this.props.dashboard ||
        this.props.filters.dashboardType !== this.state.dashboardType)
    ) {
      const { userInfo, getDashboard, getDeveloperDashboard } = this.props
      const id = userInfo ? userInfo.id : null
      this.state.dashboardType === 'dashboard'
        ? getDashboard(id, this.state)
        : getDeveloperDashboard(this.state.dashboardType, id, this.state)
      //getDashboard(id, this.state);
    }
  }

  componentWillReceiveProps(nextProps) {
    const isDashboardTypeChange =
      nextProps.route.dashboardType !== this.state.dashboardType
    if (isDashboardTypeChange) {
      this.setState(
        {
          dashboardType: nextProps.route.dashboardType
        },
        () => {
          if (this.state.startDate && this.state.endDate) {
            this.getDashboardStats()
          }
        }
      )
    } else {
      if (
        this.state.startDate &&
        this.state.endDate &&
        nextProps.dashboard === null
      ) {
        this.getDashboardStats()
      }
    }
  }

  getDashboardStats = () => {
    const { userInfo, getDashboard, getDeveloperDashboard } = this.props
    const { startDate, endDate } = this.state
    if (userInfo && startDate && endDate) {
      this.state.dashboardType === 'dashboard'
        ? getDashboard(userInfo.id, this.state)
        : getDeveloperDashboard(
            this.state.dashboardType,
            userInfo.id,
            this.state
          )
    }
  }

  handleChangeStart = (event, date) => {
    if (this.state.startDate !== date) {
      this.setState(
        {
          startDate: date
        },
        this.getDashboardStats
      )
    }
  }

  handleChangeEnd = (event, date) => {
    if (this.state.endDate !== date) {
      this.setState(
        {
          endDate: date
        },
        this.getDashboardStats
      )
    }
  }

  getMinMaxDates = () => {
    const { startDate, endDate } = this.state
    const minDate = startDate || Constants.minDateAllowed
    const maxDate = endDate || Constants.maxDateAllowed
    return { minDate, maxDate }
  }

  resetFilter = () => {
    const today = new Date()
    const { resetDashboard } = this.props
    this.setState(
      {
        startDate: today,
        endDate: today
      },
      resetDashboard
    )
  }

  render() {
    const styles = {
      datepicker: {
        marginRight: '25px'
      },
      datepickertext: {
        width: '100px'
      },
      refresh: {
        display: 'inline-block',
        position: 'relative'
      }
    }
    const keys =
      this.props && this.props.dashboard
        ? Object.keys(this.props.dashboard)
        : []
    let dashboard
    if (keys.length > 0) {
      dashboard = this.props.dashboard
    }
    let { startDate, endDate, dashboardType } = this.state
    startDate =
      startDate || (this.props.filters && this.props.filters.startDate)
    endDate = endDate || (this.props.filters && this.props.filters.endDate)
    let heading
    switch (dashboardType) {
      case 'dashboard':
        heading = ''
        break
      case 'BROKER':
        heading = 'Broker'
        break
      case 'DEVELOPER':
        heading = 'Developer'
        break
      case 'MAKAAN':
        heading = 'Makaan'
        break
      case 'OWNER':
        heading = 'Owner'
        break
    }
    const { minDate, maxDate } = this.getMinMaxDates()
    return (
      <div>
        <Header {...this.props} title='Unified RCM Dashboard' />
        <div className='dashboard'>
          <center>
            <h4>{heading} Dashboard</h4>
          </center>
          <div className='date-wrap'>
            <DatePicker
              floatingLabelText='Start Date'
              onChange={this.handleChangeStart}
              value={startDate}
              maxDate={maxDate}
              style={styles.datepicker}
              textFieldStyle={styles.datepickertext}
            />
            <DatePicker
              floatingLabelText='End Date'
              onChange={this.handleChangeEnd}
              value={endDate}
              minDate={minDate}
              style={styles.datepicker}
              textFieldStyle={styles.datepickertext}
            />
            <RefreshIndicator
              percentage={100}
              size={40}
              left={0}
              top={10}
              status='ready'
              style={styles.refresh}
              onClick={this.resetFilter}
            />
          </div>
          <DashboardGrid
            dashboardType={dashboardType}
            keys={keys}
            dashboard={dashboard}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div>
    )
  }
}

Dashboard.propTypes = {
  filters: PropTypes.object,
  userInfo: PropTypes.object,
  dashboard: PropTypes.object,
  getDashboard: PropTypes.func,
  resetDashboard: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/Dashboard.js
 **/